import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const newsletterDraftsApi = {
  /**
   * List all newsletter drafts.
   * @param {{ skip?: number; limit?: number }} [params]
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').NewsletterDraftListItem[]>>}
   */
  list: (params = {}, config = {}) =>
    mod.get('/moderators/newsletters', { ...config, params: { limit: 50, ...params } }),

  /**
   * Only `pending_review` drafts.
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  listPending: (config) => mod.get('/moderators/newsletters/pending', config),

  /**
   * Full draft with HTML body.
   * @param {number} id
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').NewsletterDraftOut>>}
   */
  get: (id, config) => mod.get(`/moderators/newsletters/${id}`, config),

  /**
   * Approve and send draft to subscriber.
   * @param {number} id
   */
  send: (id, config) => mod.post(`/moderators/newsletters/${id}/send`, null, config),

  /**
   * Send each subscriber's latest APPROVED draft (same HTML as schedule send-now).
   * Use this instead of /email/send-newsletter-all (legacy TopicSummary template).
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  sendAll: (config = {}) => mod.post('/moderators/newsletters/send-all', null, config),

  /**
   * Reject a draft.
   * @param {number} id
   */
  reject: (id, config) =>
    mod.post(`/moderators/newsletters/${id}/reject`, null, config),
};
